import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WmFlyout } from "@watermarkinsights/ripple-react";
import translate from "src/i18n/translate";
import { formatDateFullYear } from "src/features/common/helper";
import { getTaskState } from "./WorkflowTaskStepTooltip";
import { stepClass } from "./WorkflowTaskStep";
import { IN_PROGRESS_STATUS, ON_HOLD_STATUS, SKIPPED_STATUS } from "src/features/common/constants";
export function WorkFlowTaskFlyout(_a) {
    var CloseDrilldownView = _a.CloseDrilldownView, workflowTask = _a.workflowTask, open = _a.open;
    var closeDrillDownView = function () {
        CloseDrilldownView();
    };
    var flyoutWidth = "860px";
    return (_jsx(WmFlyout, { id: "drill-down-view", heading: workflowTask.title, open: open, onWmFlyoutCloseTriggered: closeDrillDownView, onWmFlyoutPrimaryTriggered: closeDrillDownView, flyoutWidth: flyoutWidth, primaryText: "Close", children: _jsx("div", { className: "fs-rpt-flyout", children: _jsx("section", { id: "fs-rpt-table", className: "workflowtasks-steps-table", children: _jsxs(Table, { children: [_jsx(TableHeader, {}), _jsx(TableBody, { workflowTask: workflowTask })] }) }) }) }));
}
function submittedDate(submittedDate) {
    return _jsx("div", { className: "date", children: formatDateFullYear(submittedDate) });
}
function dueDate(dueDate) {
    return _jsx("div", { className: "date", children: formatDateFullYear(dueDate) });
}
var GetDate = function (_a) {
    var step = _a.step;
    switch (true) {
        case !!step.submittedDate:
            return submittedDate(step.submittedDate);
        case !!step.dueDate:
            return dueDate(step.dueDate);
        default:
            return "-";
    }
};
var WorkflowTaskAssigneeName = function (_a) {
    var step = _a.step, assignee = _a.assignee, index = _a.index;
    return (_jsxs("div", { children: [_jsxs("span", { children: [" ", "".concat(assignee.firstName)] }), _jsxs("span", { children: [" ", assignee.middleName ? assignee.middleName : ""] }), _jsxs("span", { children: [" ", assignee.lastName] }), index < step.assignees.length - 1 ? "," : ""] }));
};
var WorkflowTaskRow = function (_a) {
    var step = _a.step;
    return (_jsxs("tr", { className: step.state === IN_PROGRESS_STATUS ? "in-progress datarow" : "datarow", children: [_jsx("td", { className: "datacell", children: _jsx("div", { className: "tooltip-state ".concat(stepClass(step === null || step === void 0 ? void 0 : step.state)), children: getTaskState(step === null || step === void 0 ? void 0 : step.state) }) }), _jsx("td", { className: "datacell", children: step.stepIndex + 1 }), _jsx("td", { className: "datacell", children: step.name }), _jsx("td", { className: "datacell", children: step.assignees.map(function (assignee, index) {
                    return (_jsx(WorkflowTaskAssigneeName, { step: step, assignee: assignee, index: index }, "row-".concat(index, "-").concat(step.id)));
                }) }), _jsx("td", { className: "datacell", children: step.state === ON_HOLD_STATUS || step.state === SKIPPED_STATUS ? ("-") : (_jsx(GetDate, { step: step })) })] }));
};
var TableBody = function (_a) {
    var workflowTask = _a.workflowTask;
    return (_jsx("tbody", { className: "databody", children: workflowTask.steps.map(function (step, index) {
            return _jsx(WorkflowTaskRow, { step: step }, "body-".concat(index));
        }) }));
};
var Table = function (props) {
    return (_jsx("table", { id: "flyout-table", className: "data-table -shadow", children: props.children }));
};
var TableHeader = function () {
    var columns = [
        translate("app.home.WorkflowTaskFlyout.status"),
        translate("app.home.WorkflowTaskFlyout.id"),
        translate("app.home.WorkflowTaskFlyout.StepName"),
        translate("app.home.WorkflowTaskFlyout.AssigneeName"),
        translate("app.home.WorkflowTaskFlyout.dueOrCompletedDate")
    ];
    return (_jsx("thead", { className: "dataheader", children: _jsx("tr", { className: "dataheaderrow", children: columns.map(function (column, index) {
                return (_jsx("th", { className: "dataheadercell", "data-th": column, children: _jsx("span", { children: column }) }, "column-".concat(index)));
            }) }) }));
};
